import styled from 'styled-components';

export const StyledMenuMainOption = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;
  text-transform: uppercase;
  font-family: "BebasNeue";
  margin-bottom: 24px;
  height: 49px;
  cursor: pointer;
  background: ${({ theme, $selected }) => $selected ? theme.selection : theme.menuTitle};
  opacity: ${({ $disabled }) => $disabled ? '0.5' : '1'};

  .menu-option-name {
    margin-left: 16px;
    font-size: 4.25em;
    line-height: 0.92;
    padding: 0 8px;
    background: ${({ theme }) => theme.background};
  }

  .menu-option-decorator {
    height: 100%;
    width: ${({ theme }) => theme.frameWidth};
    min-width: ${({ theme }) => theme.frameWidth};
    background: ${({ theme, $selected }) => $selected ? 'white' : theme.frame};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
  }

  .menu-option-filler {
    transition: background linear 0.2s;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.background};
  }

  &:hover {
    .menu-option-filler {
      background: ${({ theme }) => theme.menuTitle};
    }
  }
`;

